export default "__VITE_ASSET__F2omgceA__"